import Leftlayout from "../leftlayout/Leftlayout";
import NodesTable from "../nodetable/NodesTable";
// import NodeTable1 from "../nodetable/NodeTable1";

const MainNodeTable= () => {
    return ( 
        <div className="mainnodetable">
            <div className="layouttable-left">
            <Leftlayout/>
            </div>
            <div className="layouttable-right">
            <NodesTable/>
            </div>
        </div>
        );
}
 
export default MainNodeTable;